module.exports = __webpack_public_path__ + "img/2.a246d88d.jpg";